<template>
  <div class="__ReportFilter">
    <div class="row inline">
      <div>
        <CTitle>{{ $t('Usage Month') }}</CTitle>
        <div class="month-section">
          <!--Month selector / Report download button -->
          <DateRange
            class="mr-md"
            ref="data-range"
            :range="dateRange"
            :quick-range-options="quickRangeOptions"
            :min-date="minDate"
            :max-date="maxDate"
            @change="onChangeDateRange"
          />
          <CButton
            icon="get_app"
            round
            flat
            color="primary"
            :tooltip="$t('Download the report (.csv)')"
            @click="handleDownloadCsv"
          />
        </div>
      </div>
      <div class="column q-ml-xl">
        <CTitle>{{ $t('Custom Filters') }}</CTitle>
        <div class="month-section">
          <CSelector
            width="250px"
            v-model="selectedSavedFilter"
            :options="savedFilterOptions"
            emit-value
            map-options
            :use-input="false"
            @input="onChangeActiveFilter"
          />
        </div>
      </div>
    </div>
    <SelectReportColumnsDialog
      :dateRange="dateRange"
      :activeFilter="activeFilter"
      v-model="dialogDownload"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import CButton from '@/components/uikit/CButton';
import CSelector from '@/components/uikit/CSelector';
import CTitle from '@/components/uikit/CTitle';
import DateRange from '@design-system/components/DateRange';
import SelectReportColumnsDialog from '@/components/ReportFilters/SelectReportColumnsDialog';
// import DateRange from '@/components/CustomCharts/DateRange';
import { analyzer } from '@/analyzer';

const messages = {
  en: {
    'Usage Month': 'Usage Month',
    Filters: 'Filters',
    'Search by {label}.': 'Search by {label}.',
    'Monthly total cost': 'Monthly total cost',
    'Download the report (.csv)': 'Download the report (.csv)',
    'Hide filters': 'Hide filters',
    'Show filters': 'Show filters',
    Accounts: 'Accounts',
    Service: 'Service',
    Region: 'Region',
    Operation: 'Operation',
    'Instance Type': 'Instance Type',
    'Resource ID': 'Resource ID',
    'Services without resource ID': 'Services without resource ID',
    'Custom Filters': 'Custom Filters',
  },
  ja: {
    'Usage Month': '利用月',
    Filters: 'フィルター',
    'Search by {label}.': '{label}で検索',
    'Monthly total cost': '当月の合計金額',
    'Download the report (.csv)': 'レポートデータ(.csv)のダウンロード',
    'Hide filters': 'フィルターを非表示',
    'Show filters': 'フィルターを表示',
    Accounts: 'アカウント',
    Service: 'サービス',
    Region: 'リージョン',
    Operation: 'オペレーション',
    'Instance Type': 'インスタンスタイプ',
    'Resource ID': 'リソースID',
    'Services without resource ID': 'リソースIDのないサービス',
    'Custom Filters': 'カスタムフィルター',
  },
};
export default Vue.extend({
  name: 'ReportFilter',
  i18n: { messages },
  props: ['activeFilter'],
  components: {
    SelectReportColumnsDialog,
    DateRange,
    CButton,
    CTitle,
    CSelector,
  },
  data() {
    return {
      dialogDownload: false,
      quickRangeOptions: ['mtd', 'lastMonth', 'ytd', '3months', '6months', '1year'],
      dateRange: {
        start: moment()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      },
      minDate: null,
      maxDate: moment().toDate(),
      showFilters: true,
      vendor: this.$store.state.vendor,
    };
  },
  computed: {
    selectedSavedFilter: {
      get() {
        return this.activeFilter;
      },
      set(value) {
        this.$emit('update:activeFilter', value);
      },
    },
    savedFilterOptions() {
      return this.$store.getters['reportFilters/getFiltersOptions'](this.vendor);
    },
  },
  methods: {
    onChangeDateRange(range) {
      this.dateRange = range;
    },
    handleDownloadCsv() {
      analyzer.track(`Action: SaveFilter Download`);
      this.dialogDownload = true;
    },
    onChangeActiveFilter(newVal) {
      this.$router.push({
        params: {
          activeFilter: newVal,
        },
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.__ReportFilter {
  &-MoreInfo {
    font-size: $font-size-sm;
    padding-top: $space-xs;
    text-align: right;
  }
  .month-section {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
  }
  .filter-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
    .horizontal-line {
      margin-left: 16px;
      height: 1px;
      background-color: #e0e0e0;
      flex-basis: fill;
      flex-grow: 1;
    }
  }
  .filters-container {
    display: flex;
    flex-grow: 1;
    flex-flow: row wrap;
    .filter-section {
      min-width: 400px;
    }
  }
}
</style>
